import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Query Name',
    field: 'reportName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Query',
    field: 'sqlQuery',
    filter: 'text',
    width: undefined,
    searchable: true,
  },
  {
    title: 'Is Global',
    field: 'isGlobalAsText',
    filter: 'text',
    width: undefined,
    searchable: true,
  },
  {
    title: 'Created On',
    field: 'createdDateText',
    filter: 'text',
    width: undefined,
    searchable: true,
  },
  {
    title: 'Created By',
    field: 'createdBy',
    filter: 'text',
    width: undefined,
    searchable: true,
  },
  {
    title: 'Option',
    field: 'option',
    filter: 'text',
    width: undefined,
    searchable: true,
  },
];
